export function pluralify(number: number, unit: Unit): string {
  return `${number} ${(unit = number === 1 ? unit : `${unit}s`)}`;
}

export function stripQuotes(string: string): string {
  return string.replace(/"/g, "") ?? "";
}

export function sanitize(string) {
  string = string.trim(); // remove excess white-space

  if (string.length === 0) {
    return "";
  } // empty string

  // string with only white spaces
  // (after removing all spaces, length is 0)
  if (!string.replace(/\s/g, "").length) {
    return "";
  }

  return string;
}

export function capitalizeString(string) {
  string = string.charAt(0).toUpperCase() + string.slice(1);
  return string;
}

export function makeJSONString(string, matchedString = "", quotedString = "", codeString = "") {
  if (string.match(window.regExes.JSON)) {
    quotedString = quoteWrapJSONString(cleanUpJSONString(string));
    matchedString = string.match(window.regExes.JSON)[0];
    codeString = quotedString ? `<code>${quotedString}</code>` : "";
  }
  return {
    quoted: quotedString,
    string: matchedString,
    code: codeString,
  };
}

export function quoteWrapJSONString(string) {
  // Wrap quotes around JSON keys, so it can be parsed by JSON.parse
  // - The regex that recognises a key will accept a key that is alpha-numeric with "_" or "-" characters.
  const jsonStringWithQuotes = string.replaceAll(/(\d*[a-zA-Z][a-zA-Z0-9_-]{1,})/g, `"$1"`); // window.regExes.JSON_key
  // console.log(jsonStringWithQuotes)

  return jsonStringWithQuotes;
}

export function cleanUpJSONString(string, jsonString = "") {
  try {
    jsonString = string.match(window.regExes.JSON)[0];
  } catch (error) {
    console.warn(error);
    return jsonString;
  } finally {
    // Clean up empty keys

    jsonString = jsonString
      // Remove empty keys with no value: {"key_name"}
      .replace(/{\d*[a-zA-Z][a-zA-Z0-9_-]{1,}}/, "{}")
      // Remove empty key at the end of container JSON '"key_name:" }'
      .replace(/\d*[a-zA-Z][a-zA-Z0-9_-]{1,}\:\s*}/, "}")
      // Remove empty brackets
      .replace(/\d*[a-zA-Z][a-zA-Z0-9_-]{1,}\:\s\[\s*\]/, "")
      // Remove trailing commas ", }"
      .replace(/,\s*\}/, " }")
      // Remove leading commas "{, "
      .replace(/\{\s*,\s*/, "{")
      // Remove double commas ", ,"
      .replace(/,\s*,/, ",");

    // console.log(jsonString)
    return jsonString;
  }
}
